'use strict';

angular.module('mobile-apps').controller('ExportTranslationsModalController', [
	'$scope',
	'AvailableLanguages',
	'EventTracker',
	'ModalData',
	'EntryMain',
	'FileMain',
	'TranslationImport',
	'Utilities',
	'$modalInstance',
	'$window',
	'$http',
	'$q',
	function (
		$scope,
		AvailableLanguages,
		EventTracker,
		ModalData,
		EntryMain,
		FileMain,
		TranslationImport,
		Utilities,
		$modalInstance,
		$window,
		$http,
		$q
	) {

		$scope.data = {
			availableLanguages: [],
			appLanguages: [],
			displayExportSelected: false,
			exportFile: undefined,
			exportEntries: 'selected',
			exportLanguages: {},
			exportOptions: [
				{
					id: 'useSrcFileName',
					name: 'Use Source File Name',
					value: true,
					availableFor: [
						'angular_translate_json',
						'chrome_i18n_json',
						'csv',
						'tsv',
						'ember_i18n_json_module',
						'gettext_po',
						'gettext_pot',
						'go_i18n_json',
						'ini',
						'i18next_json',
						'java_properties',
						'microsoft_resw',
						'microsoft_resx',
						'mozilla_i18n_json',
						'mozilla_properties',
						'nested_json',
						'node_2_json',
						'react_nested_json',
						'react_simple_json',
						'ruby_on_rails_yaml',
						'symfony_yaml',
						'symfony2_yaml',
						'strings',
						'xml',
						'xliff',
						'xls',
						'arb',
						'laravel_php'
					]
				},
				{
					id: 'exportDrafts',
					name: 'Export Also Drafts',
					value: false,
					availableFor: [
						'csv',
						'tsv',
						'xlsMulti',
						'xls'
					]
				},
				{
					id: 'exportOnlyWithTranslation',
					name: 'Only with translation',
					value: false,
					availableFor: [
						'angular_translate_json',
						'chrome_i18n_json',
						'csv',
						'tsv',
						'ember_i18n_json_module',
						'gettext_po',
						'gettext_pot',
						'go_i18n_json',
						'i18next_json',
						'ini',
						'java_properties',
						'microsoft_resw',
						'microsoft_resx',
						'mozilla_i18n_json',
						'nested_json',
						'node_2_json',
						'react_nested_json',
						'react_simple_json',
						'ruby_on_rails_yaml',
						'symfony_yaml',
						'symfony2_yaml',
						'strings',
						'xml',
						'xliff',
						'xlsMulti',
						'xls',
						'arb',
						'laravel_php'
					]
				},
				{
					id: 'exportOnlyWithTranslation',
					name: 'Only with translation',
					value: true,
					availableFor: [
						'tmx',
						'tbx'
					]
				},
				{
					id: 'includeMetadata',
					name: 'Include Metadata',
					value: true,
					availableFor: [
						'csv',
						'tsv',
						'xliff',
						'xlsMulti',
						'xls'
					]
				},
				{
					id: 'ignoreDuplicates',
					name: 'Ignore Duplicates',
					value: true,
					availableFor: [
						'nested_json',
						'react_nested_json',
						'ruby_on_rails_yaml',
						'symfony_yaml',
						'symfony2_yaml',
						'ember_i18n_json_module',
						'laravel_php'
					]
				},
                {
                    id: 'includeContextUrl',
                    name: 'Include Context URL',
                    value: false,
                    availableFor: ['xliff', 'xls', 'xlsMulti']
                }
			],
			exportFileTypes: [
				{
					id: 'xliff',
					name: 'Xliff (.xliff)'
				},
				{
					id: 'xls',
					name: 'Excel (.xlsx)'
				},
				{
					id: 'xlsMulti',
					name: 'Multi Lang. Excel (.xlsx)'
				},
				{
					id: 'strings',
					name: 'Apple (.strings)'
				},
				{
					id: 'xml',
					name: 'Android (.xml)'
				},
				{
					id: 'gettext_po',
					name: 'Gettext PO File (.po)'
				},
				{
					id: 'gettext_pot',
					name: 'Gettext POT File (.pot)'
				},
				{
					id: 'microsoft_resw',
					name: 'Microsoft (.resw)'
				},
				{
					id: 'microsoft_resx',
					name: 'Microsoft (.resx)'
				},
				{
					id: 'angular_translate_json',
					name: 'Angular Translate (.json)'
				},
				{
					id: 'node_2_json',
					name: 'i18n-node-2 (.json)'
				},
				{
					id: 'i18next_json',
					name: 'i18next (.json)'
				},
				{
					id: 'chrome_i18n_json',
					name: 'Chrome i18n (.json)'
				},
				{
					id: 'mozilla_i18n_json',
					name: 'Mozilla i18n (.json)'
				},
				{
					id: 'go_i18n_json',
					name: 'go-i18n (.json)'
				},
				{
					id: 'java_properties',
					name: 'JAVA (.properties)'
				},
				{
					id: 'mozilla_properties',
					name: 'Mozilla (.properties)'
				},
				{
					id: 'ember_i18n_json_module',
					name: 'Ember i18n Module (.js)'
				},
				{
					id: 'nested_json',
					name: 'Nested JSON (.json)'
				},
				{
					id: 'react_nested_json',
					name: 'React Nested (.json)'
				},
				{
					id: 'react_simple_json',
					name: 'React Simple (.json)'
				},
				{
					id: 'ruby_on_rails_yaml',
					name: 'Ruby on Rails (.yaml)'
				},
				{
					id: 'symfony_yaml',
					name: 'Symfony (.yaml)'
				},
				{
					id: 'symfony2_yaml',
					name: 'Symfony 2 (.yaml)'
				},
				{
					id: 'csv',
					name: 'Table (.csv)'
				},
				{
					id: 'tsv',
					name: 'Tab-Separated (.tsv)'
				},
				{
					id: 'ini',
					name: 'Ini File (.ini)'
				},
				{
					id: 'arb',
					name: 'Flutter (.arb)'
				},
				{
					id: 'laravel_php',
					name: 'Laravel File (.php)'
				},
				{
					id: 'tmx',
					name: 'Trans. Memory (.tmx)'
				},
				{
					id: 'tbx',
					name: 'Term Base (.tbx)'
				}
			],
			exportFileType: 'xliff'
		};


		/**
		 * Returns if the option is available for the exportFileType
		 */
		$scope.isOptionAvailable = function(optionData, exportFileType) {
			if (!optionData.hasOwnProperty('availableFor')) {
				return true;
			}

			if (optionData.availableFor.indexOf(exportFileType) !== -1) {
				return true;
			}

			return false;
		};



		/**
		 * Exports the data as given type (xliff, strings, androidXml)
		 */
		$scope.exportTranslations = function () {
			// Get the languages which should be exported
			var languagesToExport = [];
			for (var languageIso in $scope.data.exportLanguages) {
				if ($scope.data.exportLanguages[languageIso] === true) {
					languagesToExport.push(languageIso);
				}
			}

			if (languagesToExport.length === 0) {
				Utilities.showMessage('No language selected', 'At least one language has to be selected to start an export.', 'error');
				return;
			}

			var exportOptions = {};
			$scope.data.exportOptions.forEach(function(option) {
				if($scope.isOptionAvailable(option, $scope.data.exportFileType)) {
					exportOptions[option.id] = option.value;
				}
			});

			var fileType = $scope.data.exportFileType;
			if (fileType === 'xlsMulti') {
				fileType = 'xls';
				exportOptions.multiLanguageFile = true;
			}


			var downloadUrl = '/v1/projects/' + ModalData.mobileApp._id + '/export-translations';
			downloadUrl += '?languages=' + encodeURIComponent(JSON.stringify(languagesToExport));
			downloadUrl += '&type=' + fileType;

			if (ModalData.groupId) {
				downloadUrl += '&groupId=' + ModalData.groupId;
			}

			var exportEntries;
			if ($scope.data.exportEntries === 'all') {
				// Export all entries so request via GET
				// (Supported by all browsers)

				downloadUrl += '&options=' + encodeURIComponent(JSON.stringify(exportOptions));

				return $q(function (resolve, reject) {
					$http({url: downloadUrl, method: 'GET', responseType: 'arraybuffer' })
						.then(function (response) {
							// Track the export event
							var trackData = {
								languages: languagesToExport,
								options: exportOptions,
								data_type: fileType
							};
							EventTracker.track('Export Success', 'Data Export', trackData);

							var headers = response.headers();
							var headerKeys = Object.keys(headers);

							// Get Content-Type
							var contentType = '';
							if (headerKeys.indexOf('content-type') !== -1) {
								contentType = headers['content-type'].split(';')[0].trim();
							}

							// Get File-Name
							var fileName = 'export.txt';
							if (headerKeys.indexOf('content-disposition') !== -1 && headers['content-disposition'].indexOf('filename') !== -1) {
								var fileNameTemp = headers['content-disposition'].split('filename=');
								fileNameTemp = fileNameTemp[1].trim();
								fileNameTemp = fileNameTemp.slice(1, -1);
								if (fileNameTemp && fileNameTemp.length !== 0) {
									fileName = fileNameTemp;
								}
							}

							// Tells the browser to "download" the data
							var blob = new Blob([response.data], { type: contentType });
							// To be sure that it works in all browsers use saveAs
							// from FileSaver.js
							window.saveAs(blob, fileName);

							$modalInstance.close({});
							resolve();
						})
						.catch(function (response) {
							var errorMessage = 'There was a problem while exporting data';
							if(response.status === 409) {
								errorMessage = new TextDecoder('utf-8').decode(response.data);
							}

							Utilities.showMessage(
								'Error!',
								errorMessage,
								'error'
							);
							$modalInstance.close({});
							reject(errorMessage);
						});
				});
			}

			var getEntriesPromise = $q.when(ModalData.entries);
			if ($scope.data.exportEntries === 'file') {
				// Try to return file unzipped if possible
				exportOptions.returnUnzipped = true;

				getEntriesPromise = FileMain.getFiles(ModalData.mobileApp._id, ModalData.groupId, ModalData.exportLanguageId)
					.then(
						function (data) {
							if (!data.files.hasOwnProperty($scope.data.exportFile)) {
								return $q.reject('No data for file found.');
							}

							return data.files[$scope.data.exportFile];
						}
					);
			}

			// Export only a few entries so request via POST
			// (Supported by all browsers except Safari)
			$scope.processingExport = true;
			getEntriesPromise
				.then(
					function (exportEntries) {
						downloadUrl += '&options=' + encodeURIComponent(JSON.stringify(exportOptions));

						return $q(function (resolve, reject) {
							$http(
								{
									url: downloadUrl,
									method: 'POST',
									data: {
										data: {
											entries: exportEntries
										}
									},
									responseType: 'arraybuffer'
								}
							)
							.then(function (response) {
								// Track the export event
								var trackData = {
									languages: languagesToExport,
									options: exportOptions,
									data_type: fileType
								};
								EventTracker.track('Export Selected Success', 'Data Export', trackData);

								$scope.processingExport = false;
								var headers = response.headers();
								var headerKeys = Object.keys(headers);

								// Get Content-Type
								var contentType = '';
								if (headerKeys.indexOf('content-type') !== -1) {
									contentType = headers['content-type'].split(';')[0].trim();
								}

								// Get File-Name
								var fileName = 'export.txt';
								if (headerKeys.indexOf('content-disposition') !== -1 && headers['content-disposition'].indexOf('filename') !== -1) {
									var fileNameTemp = headers['content-disposition'].split('filename=');
									fileNameTemp = fileNameTemp[1].trim();
									fileNameTemp = fileNameTemp.slice(1, -1);
									if (fileNameTemp && fileNameTemp.length !== 0) {
										fileName = fileNameTemp;
									}
								}

								// Tells the browser to "download" the data
								var blob = new Blob([response.data], { type: contentType });
								// To be sure that it works in all browsers use saveAs
								// from FileSaver.js
								window.saveAs(blob, fileName);

								$modalInstance.close({});
								resolve();
							})
							.catch(function (response) {
								var errorMessage = 'There was a problem exporting the data';
								if(response.status === 409) {
									errorMessage = new TextDecoder('utf-8').decode(response.data);
								}
								reject(errorMessage);
							});
						});
					}
				)
				.catch(
					function(error) {
						Utilities.showMessage(
							'Error!',
							error,
							'error'
						);
					}
				);

		};


		/**
		 * Close modal
		 */
		$scope.close = function() {
			$modalInstance.dismiss();
		};


		/**
		 * Initializes the needed data
		 */
		$scope.init = function() {

			var availableLanguagesPromise = AvailableLanguages.get().$promise;
			var mobileAppPromise = EntryMain.loadMobileApp(ModalData.mobileApp._id, false);

			// AL-850 xliff export did not work in safari because of a bug in
			// the browser. Sw we do allow export selected only for other
			// browsers for now.
			if (navigator.userAgent.indexOf('Safari') === -1 || navigator.userAgent.indexOf('Chrome') !== -1) {
				if (ModalData.entries && ModalData.entries.length !== 0) {
					// By default export selected if entries are given
					// but give option to export all instead
					$scope.data.displayExportSelected = true;
				} else if (ModalData.exportFile && ModalData.exportLanguageId) {
					$scope.data.exportFile = ModalData.exportFile;

					// When only a single file is supposed to get exported allow also
					// export of stringsdict
					$scope.data.exportFileTypes.push({
						id: 'stringsdict',
						name: 'Apple (.stringsdict)'
					});

					// Automatically select the correct file type if found
					var type = $scope.data.exportFile.toLowerCase().slice($scope.data.exportFile.lastIndexOf('.') + 1);
					var knownTypes = $scope.data.exportFileTypes.map(function (entry) { return entry.id; });
					if (knownTypes.indexOf(type) !== -1) {
						$scope.data.exportFileType = type;
					}

					$scope.data.exportEntries = 'file';
				} else {
					// No entries given so export all
					$scope.data.exportEntries = 'all';
				}
			} else {
				// Is safari so always export all
				$scope.data.exportEntries = 'all';
			}

			if (ModalData.languages && angular.isArray(ModalData.languages)) {
				ModalData.languages.forEach(function(languageIso) {
					if (languageIso) {
						$scope.data.exportLanguages[languageIso] = true;
					}
				});
			}

			$q.all([availableLanguagesPromise, mobileAppPromise]).then(
				function(results) {
					$scope.data.availableLanguages = results[0];

					// Automatically set all languages except base language to
					// be exportable and check them by default
					for (var languageId in EntryMain.languages) {
						var languageIso = EntryMain.languages[languageId].name;
						$scope.data.appLanguages.push(EntryMain.languages[languageId]);
						if (!ModalData.selectedLanguages || !angular.isArray(ModalData.selectedLanguages) || ModalData.selectedLanguages.indexOf(languageIso) !== -1) {
							// If selected languages is given only select
							// the given ones. If it is not defined select
							// all languages.
							$scope.data.exportLanguages[languageIso] = true;
						}
					}
				}
			);
		};


		$scope.init();
	}
]);
